export default __webpack_public_path__ + "static-bigflip/media/icon-step-5.36f1d360.png";